import { useState } from 'react';
import { tools } from '../components/ToolbarDraw';

interface UseToolsOptions {
  initialTool?: string;
  initialColor?: string;
  initialThickness?: number;
}

// Custom hook to manage drawing tools, colors, and thicknesses
export const useTools = (options: UseToolsOptions = {}) => {
  const {
    initialTool = tools.draw,
    initialColor = '#000000',
    initialThickness = 24,
  } = options;

  const [selectedTool, setSelectedTool] = useState(initialTool);
  const [selectedColor, setSelectedColor] = useState(initialColor);
  const [selectedThickness, setSelectedThickness] = useState(initialThickness);

  const handleToolChange = (tool: string) => {
    setSelectedTool(tool);
  };

  const handleColorChange = (color: string) => {
    setSelectedColor(color);
  };

  const handleThicknessChange = (thickness: number) => {
    setSelectedThickness(thickness);
  };

  return {
    // Current states
    selectedTool,
    selectedColor,
    selectedThickness,
    
    // Handler functions
    handleToolChange,
    handleColorChange,
    handleThicknessChange,
    
    // Setter functions (for direct state updates if needed)
    setSelectedTool,
    setSelectedColor,
    setSelectedThickness,
    
    // Constants
    tools,
  };
};
